// extracted by mini-css-extract-plugin
export default {"mainDiv":"style_mainDiv__iHVYq"};